import APIRequest from './APIRequest';

export const GetCompanyListBasic = () => {
    return APIRequest({
        url: `Company/GetCompanyListBasic`,
        method: 'get'
    });
}